<template>
  <div class="avecor-table" style="background:#ccc !important"> 
    <!-- TABLE --->
    <v-data-table
      :headers="headers"
      :items="orderedProductsArray"
      ref="table"
      :search="search"
      :options="{itemsPerPage:15}"
      hide-default-header
      class="avecor-ordered-products-table no-bars"
      style="overflow-y:scroll;background:#eee"
      fixed-header
      :height="387"
      dense
    >
      <template v-slot:header="{ props: { headers } }">
        <thead>
          <tr>
            <th :key="h.value+'-'+index" v-for="(h, index) in headers" style="font-size:11px;font-weight:600" class="px-1">
              <div v-if="h.value !== 'batchStatusChange'"><span>{{h.text}}</span></div>
              <div v-else><span></span></div>
              <!-- <div >
                {{h.value}}
              </div> -->
              <div v-if="h.value === 'productVariationId'" style=";margin-top:10px;">
                <v-autocomplete
                  autocomplete="off"
                  v-model="pvFilter"
                  :items="pvOptions"
                  @change="v => setPvFilter(v)"
                  hide-details
                  label="Suodata tuotevariaatiolla"
                  dense
                  spellcheck="false"
                  item-text="text"
                  item-value="value"
                  class="avecor-select blue-text"
                  style="font-size:8px;font-weight:400"
                />
              </div>
              <div v-if="h.value === 'orderStatus'" style="max-height:20px;;">
                <div>
                  <span style="font-size:8px;font-weight:400;padding-right:3px;">Näytä myös toimitetut</span>
                  <v-icon v-if="showDelivered" @mouseup.stop="showDelivered = false" style="cursor:pointer;z-index:1 !important;padding-top:2px;" size="14"  color="green">fas fa-check-square</v-icon>
                  <v-icon v-else @mouseup.stop="showDelivered = true" style="cursor:pointer;padding-top:2px;" size="14" color="grey">far fa-square</v-icon>
                </div>
                
              </div>
              
              <!-- <div v-if="h.value === 'orderInvoiceStatus'" style="max-height:20px;max-width:67px;">
                <v-autocomplete
                  autocomplete="off"
                  v-model="orderInvoiceFilter"
                  :items="settings.orderedProductInvoiceStatusArray"
                  @change="batchOrderUpdate('orderInvoiceStatus')"
                  hide-details
                  label="Suodata"
                  dense
                  spellcheck="false"
                  item-text="text"
                  item-value="id"
                  class="avecor-select"
                />
              </div> -->
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:item="{ item, index }"><!-- , expand, isExpanded -->
        <tr style="height:25px;" class="hide-field-details">
          <!--<td class="text-xs-left">{{ item.number }}</td>-->
          <!-- <td class="justify-center layout px-0">
            <v-icon style=""
              :size="settings.tableSelectIconsSize"
              @click="deleteItem(item)"
            >
              far fa-trash-alt
            </v-icon>
          </td> -->
          <td style="max-width:30px" :class="index === 0 ? 'pt-3' : ''">
            <v-text-field
              slot="input"
              :value="customFormatter(item.order_created_at.seconds * 1000)"
              label="Edit"
              class="avecor-select"
              single-line
              disabled
            ></v-text-field>
          </td>
          <td class="text-xs-left" @click="copyToClipboard(item.netvisorId)">
            <v-text-field
              :value="item.netvisorId"
              class="avecor-select"
              disabled/>
          </td>
          <!-- <td>
            <v-text-field
              :value="item.orderSummary"
              class="avecor-select"
              :auto-grow="true"
              disabled/>
          </td> -->
          <td class="maxw-100" @click="copyToClipboard(companies[item.companyId] !== undefined ? companies[item.companyId].companyName : '')">
            <v-text-field
              :value="companies[item.companyId] !== undefined ? companies[item.companyId].companyName : ''"
              class="avecor-select"
              disabled/>
          </td>
          <!--@change="inlineSaveName(item)"
          item-text="text"-->
          <td>
            <v-autocomplete
              :value="item.productVariationId"
              :items="getCatalogProductsAndVariations()"
              item-text="text"
              item-value="value"
              cache-items
              @change="inlineSaveProductVariationChange($event,item.id)"
              class="avecor-select avecor-ordered-producet-select"
            >
            </v-autocomplete>
          </td>
          <td class="maxw-100">
            <v-text-field
              :value="item.quantity"
              class="avecor-select"
              disabled/>
          </td>
          <td >
            <v-autocomplete
              :disabled="true"
              autocomplete="off"
              :value="item.orderStatus"
              :items="settings.orderedProductStatusArray"
              persistent-hint
              item-text="text"
              item-value="id"
              class="avecor-select"
            />
          </td>
          <td >
            <v-autocomplete
              :disabled="true"
              autocomplete="off"
              :value="item.orderInvoiceStatus"
              :items="settings.orderedProductInvoiceStatusArray"
              persistent-hint
              item-text="text"
              item-value="id"
              class="avecor-select"
            />
          </td>
        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import shared from './../../shared'

export default {
    props: ['productId'],
    created () {
      this.createVariationName = shared.createVariationName
    },
    data: () => ({
      pvFilter:'all',
      showDelivered:false,
      pvOptions:[],
      showInvoiced:false,
      dialog: false,
      table: null,
      autogrow: true,
      search: '',
      headers: [
        //{ text: 'Actions ', value: 'name', align: 'center', sortable: false },
        { text: 'Tilauksen pvm.', value: 'addedDate', align: 'left', sortable: true},
        { text: 'Netvisor Id', value: 'firstName', align: 'left', sortable: true},
        //{ text: 'Tilauskooste', value: 'lastName', align: 'left', sortable: true},
        { text: 'Yritys', value: 'companyId', align: 'left', sortable: true},
        { text: 'Tuotevariaatio', value: 'productVariationId', align: 'left', sortable: true},
        { text: 'Määrä', value: 'quantity', align: 'left', sortable: true},
        { text: 'Toim. status', value: 'orderStatus', align: 'left', sortable: true},
        { text: 'Lask. status', value: 'orderInvoiceStatus', align: 'left', sortable: true},
      ],
      orderedProductsArray:[]
    }),
    mounted() {
      const table = this.$refs.table
      this.getOrderedProducts()
    },
    computed: {
      getContacts(){
        var id = this.companyId
        var contacts = this.contacts
        var s = Object.keys(this.contacts).reduce(function(result, key) {
          var c = contacts[key]
          if(c.companyId === id) {
            result.push({...c});
          }
          return result;
        }, []);
        
        console.log(s)
        return s
      },
      getCompanies(){
        var companies = this.companies
        return Object.keys(this.companies).map(function(key, index) {
          var c = companies[key]
          return {text: c.companyName, value: c.id}
        })
      },
      ...mapFields([
        "contact.contacts",
        "order.orders",
        "product.products",
        "productVariation.productVariations",
        "orderedProduct.orderedProducts",
        "company.companies",
        "settings",
        "newOrderDetails.samplesArray",
        "newOrderDetails.deliveryCharges",
        "newOrderDetails.positioningCharges"
      ]),
      
    },
    watch: {
      pvFilter:function (val) {
        this.getOrderedProducts()
      },
      showDelivered:function (val) {
        this.getOrderedProducts()
      },
      productId:function (val) {
        this.pvFilter = 'all'
        this.getOrderedProducts()
      },
      orderedProducts: function (val) {
        this.getOrderedProducts()
        this.getCatalogProductsAndVariations()
      },
    },
    methods: {
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      setPvFilter(v){
        console.log(v)
        this.pvFilter = v
      },
      getCatalogProductsAndVariations(){
        var products = this.products
        var productVariations = this.productVariations
        var catalogProducts = []
        Object.keys(productVariations).forEach(key => {
          var pv = productVariations[key]
          products[pv.productId] ? catalogProducts.push({text: products[pv.productId].name.fi + " - " + this.createVariationName(pv), value: pv.id}) : ''//console.log(key)
        })
        return catalogProducts
      },
      getOrderedProducts(){
        var productId = this.productId
        var orderedProducts = this.orderedProducts
        var productVariations = this.productVariations
        var orders = this.orders
        this.pvOptions = [
          {text: "Kaikki variaatiot", value: 'all'}
        ]
        var ops = []
        for (const key in orderedProducts){
          var op = orderedProducts[key]
          var pushProduct = false
          if(op.productId === productId) {
            var products = this.products
            var pv = productVariations[op.productVariationId]
            this.pvOptions.push({text: products[pv.productId].name.fi + " - " + this.createVariationName(pv), value: pv.id})
            
            var os = op.orderStatus
            if(this.showDelivered){
              if(this.pvFilter && this.pvFilter === op.productVariationId){
                
                pushProduct = true
              }
              else if(this.pvFilter === 'all'){
                pushProduct = true
              }
            }
            else if (os !== 'productsShipped'){
              if(this.pvFilter && this.pvFilter === op.productVariationId){
                
                pushProduct = true
              }
              else if(this.pvFilter === 'all'){
                console.log("HERE")
                pushProduct = true
              }
            }
          }
          if(pushProduct){
            ops.push({
              ...op, 
              companyId:orders[op.orderId].companyId,
              //orderSummary:orders[op.orderId].orderSummary,
              netvisorId:orders[op.orderId].netvisorId,
              quantity:op.quantity,
              orderStatus:op.orderStatus,
              orderInvoiceStatus:op.orderInvoiceStatus,
              order_created_at:orders[op.orderId].created_at
            })
          }
        }

        ops = ops.sort(function(a,b){
          var aDate = 0
          var bDate = 0
          if(a.created_at && a.created_at.seconds){
            var aDate = new Date(a.created_at.seconds * 1000)
          }
          if(b.created_at && b.created_at.seconds){
            var bDate = new Date(b.created_at.seconds * 1000)
          }
          return  bDate - aDate
        });

        /* ops = ops.sort(function(a,b){
          console.log(a.arrivalDate)
          return new Date(a.arrivalDate) - new Date(b.arrivalDate)
        }); */

        this.orderedProductsArray = ops

        /* this.orderedProductsArray =  Object.keys(this.orderedProducts).reduce(function(result, key) {
          var op = orderedProducts[key]
          if(op.productId === productId) {
            //console.log(orders[op.orderId].companyId)
            result.push({
              ...op, 
              companyId:orders[op.orderId].companyId,
              //orderSummary:orders[op.orderId].orderSummary,
              netvisorId:orders[op.orderId].netvisorId,
              quantity:op.quantity,
              orderStatus:op.orderStatus,
              orderInvoiceStatus:op.orderInvoiceStatus,
              order_created_at:orders[op.orderId].created_at
            });
          }
          return result;
        }, []); */

      },
      customFormatter(date) {
        var da = dateFormat(date, "yyyy-mm-dd")
        return da
        
        //moment(date).format('MMMM Do YYYY, h:mm:ss a');
      },
      inlineSaveOrderDetails(event, field,orderId){
        this.$store.dispatch('order/set', {
          id:orderId,
          [field]:event,
        })
      },
      inlineSaveProductVariationChange(productVariationId,orderedProductId){
        var productId = this.productVariations[productVariationId].productId
        /* console.log(orderedProductId)
        console.log(productVariationId)
        console.log(productId) */
        this.orderedProductsArray = []
        
        if (orderedProductId !== undefined && orderedProductId !== ""
          && productVariationId !== undefined && productVariationId !== ""
          && productId !== undefined && productId !== "") {
          this.$store.dispatch('orderedProduct/set', {
            id:orderedProductId,
            productVariationId,
            productId
          }).then((data) => {
            //console.log(data)
            this.getOrderedProducts()
          })
          
        }
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/ProductOrderedProductsTable.vue